<template>
  <div class="radio-knob-row-container">
    <div
      v-for="(knob, index) in knob_cells"
      :key="`knob-${index}-id${knob.id || 0}`"
      class="radio-knob-row-cell"
    >
    <!-- :style="`width: ${width || 128}px; height: ${height || 32}px;`" -->
      <FillableCell
        :width="width"
        :height="height"
      >
        <template #content>
          <RadioButtonKnob
            v-if="knob.id"
            :is_on="knob.id === selected_id"
            :is_disabled="is_disabled"
            @radioButtonKnobClicked="handleRadioButtonKnobClicked(knob)"
          />
        </template>
      </FillableCell>
    </div>
  </div>
</template>

<script>
import RadioButtonKnob from '@/components/WorkPackageWIP/RadioButtonKnob.component.vue';
import FillableCell from '@/components/WorkPackageWIP/FillableCell.component.vue';

  export default {
    components: {
      RadioButtonKnob,
      FillableCell,
    },

    props: [
      'knobs', // is array of objects, has at least id (number)
      'selected_id', // is number, contains integer value of single active id
      'cell_count', // is number, defines max cell count to instantiiate blank cells aswell
      'is_disabled', // is boolean, toggles wether knobs can be toggled
      'width', // is number, is streamlined width for all elements in matrix
      'height', // is number, is streamlined height for all elements in matrix
    ],

    data: () => ({
      knob_cells: [],
    }),

    methods: {
      handleRadioButtonKnobClicked(knob) {
        if(this.selected_id != knob.id) {
          this.$emit('knobClicked', knob.id);
        }
        else {
          this.$emit('knobClicked', -1);
        }
      },
    },

    mounted() {
      let arr = this.knobs;
      let i = 0; // array index of function, only gets incremented when match is found
      let j = 1; // current level, gets incremented regardless
      let max = this.cell_count || 4;
      while(j <= max) {
        if(i < arr.length && arr[i].level === j) {
          this.knob_cells.push({ index: i, id: arr[i].id, });
          j++;
          i++;
        }
        else {
          this.knob_cells.push({ index: -1 });
          j++;
        }
      }
    },
  }
</script>

<style>
.radio-knob-row-container {
  display: flex;
}
.radio-knob-row-cell {
  /* border: 1px black solid; */
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
